import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_GROWTH_MEMBERSHIP_UI_UPDATE = createFcmDetails('growth_membership_ui_update', {
	owner: 'growth',
	context: 'PSF Membership Ask page',
	description: 'Rollout FCM for replacing the Super Signer membership ask UI with a more general UI',
	import: false,
});
